
export default {
  HOST_URL: process.env.NEXT_PUBLIC_HOST_URL || "",
  HOST_DOMAIN: process.env.NEXT_PUBLIC_HOST_DOMAIN || "",
  PROTOCOL: process.env.NODE_ENV === "development" ? "http" : "https",
  BUISNESS_NUMBER: "9238764656",
  HIDE_BOOK_NOW: ["bhopal", "ujjain", "pune","coimbatore","mandsaur","delhi","ahemdabad","ratlam","kota","delhi","gurugram","mumbai","trivendram","ahemdabad","noida"],
  DEFAULT_CITY: "indore",
  SUPPORT_EMAIL: "info@turfbooking.in",
};

